import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取全部分类的id和name数据列表（#107） */
export function getCategoryIdAndNameList() {
  return request("".concat(BASE_URL) + "/product/category/onlyIdAndName/list", METHOD.GET);
}

/* 根据父级分类获取子分类数据列表（#164） */
export function getCategoryListByParentId(id) {
  return request("".concat(BASE_URL) + "/product/category/parent/" + id + "/son/list", METHOD.GET);
}

/* 更新商品分类排序信息数据（#165） */
export function updateCategoryIndex(data) {
  return request("".concat(BASE_URL) + "/product/category/sort", METHOD.PUT, data);
}

/* 删除分类信息数据（#9990） */
export function deleteCategory(id) {
  return request("".concat(BASE_URL) + "/product/category/" + id, METHOD.DELETE);
}

/*新增商品分类信息数据（#186） */
export function addCategory(data) {
  return request("".concat(BASE_URL) + "/product/category", METHOD.POST, data);
}

/* 获取分类信息（#170） */
export function getCategoryDetail(id) {
  return request("".concat(BASE_URL) + "/product/category/" + id, METHOD.GET);
}

/* 更新分类信息数据（#171） */
export function updateCategoryInfo(data) {
  return request("".concat(BASE_URL) + "/product/category", METHOD.PUT, data);
}
export default {
  getCategoryIdAndNameList: getCategoryIdAndNameList,
  getCategoryListByParentId: getCategoryListByParentId,
  updateCategoryIndex: updateCategoryIndex,
  deleteCategory: deleteCategory,
  addCategory: addCategory,
  updateCategoryInfo: updateCategoryInfo,
  getCategoryDetail: getCategoryDetail
};